import React from 'react'
import * as Yup from 'yup'
import { Formik } from 'formik'

import Axios from '@components/Axios'
import Card from '@components/Card'
import Modal from '@components/Modal'
import Button from '@components/Button'

import FormGroupManager from './components/FormGroupManager'

import './styles.scss'

const AddEdit = props => {
  let { close, item, updateList } = props

  const validationSchemaEdit = Yup.object().shape({
    password: Yup.string(),
    name: Yup.string().required('REQUIRED'),
    permissions: Yup.array().min(1).required('REQUIRED'),
    email: Yup.string().email('REQUIRED').required('REQUIRED'),
  })


  const validationSchemaCreate = Yup.object().shape({
    name: Yup.string().required('REQUIRED'),
    password: Yup.string().required('REQUIRED'),
    permissions: Yup.array().min(1).required('REQUIRED'),
    email: Yup.string().email('REQUIRED').required('REQUIRED'),
  })

  const schema = {
    enableReinitialize: true,
    initialValues: { ...item },
    validationSchema: item._id ? validationSchemaEdit : validationSchemaCreate
  }

  const footer = submit => {
    return <Button onClick={submit}>MANAGER_ADD_CARD_SEND</Button>
  }

  const onSuccess = () => {
    close()
    updateList()
  }

  const add = ({ handleSubmit, ...formik }) => {
    return (
      <Card footer={() => footer(handleSubmit)}>
        <FormGroupManager {...props} formik={formik} />
      </Card>
    )
  }

  const edit = ({ handleSubmit, ...formik }) => {
    return (
      <Modal
        open={item}
        close={close}
        title="MANAGER_EDIT_MODAL_TILE"
        actions={<Actions onSubmit={handleSubmit} />}
      >
        <FormGroupManager {...props} formik={formik} />
      </Modal>
    )
  }

  const Actions = ({ onSubmit }) => {
    return (
      <div className="actions">
        <Button color="secondary" onClick={() => close()}>
          MANAGER_BUTTON_CLOSE
        </Button>
        <Button onClick={onSubmit}>MANAGER_ADD_CARD_SEND</Button>
      </div>
    )
  }

  let params = {}
  if (item._id) {
    params = {
      method: 'put',
      others: item._id
    }
  } else {
    params = {
      method: 'post'
    }
  }

  const onSubmit = ({ values, submit, resetForm }) => {
    submit({ params: values })
    resetForm()
  }

  return (
    <div className="AddEdit">
      <Axios api="administrators" {...params} onSuccess={onSuccess}>
        {({ submit }) => (
          <Formik
            {...schema}
            onSubmit={(values, event) => onSubmit({ ...event, values, submit })}
          >
            {formik => (item._id ? edit(formik) : add(formik))}
          </Formik>
        )}
      </Axios>
    </div>
  )
}

export default AddEdit
